// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PolymatchSection_2 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center; /* Center the buttons */
    gap: 20px; /* Consistent spacing */
    margin-top: 20px; /* Add space above the section if needed */
}

.Polymatch_Age4, .Polymatch_Age5, .Polymatch_Age8, .Polymatch_Age11 {
    width: auto; /* Set consistent width */
    padding: 15px 25px; /* Uniform padding */
    border-radius: 8px; /* Rounded corners */
    text-align: center;
    cursor: pointer;
    transition: background-color 0.3s ease; /* Smooth hover effect */
}
.Polymatch_Age4 {
  background-color: #dd2ba2;
}
.Polymatch_Age5 {
    background-color: #dbaf1f;
}

.Polymatch_Age8  {
    background-color: #688cd9;
}
.Polymatch_Age11{
    background-color: #58da6e;
}
.Polymatch_Age4:hover, .Polymatch_Age8:hover, .Polymatch_Age11:hover {
  background-color: #483d8b; /* Darker hover color */
  color: white; /* Change text color on hover for contrast */
}
.Polymatch_Age4 a, .Polymatch_Age8 a, .Polymatch_Age11 a {
  color: white;
  text-decoration: none;
  font-weight: bold;
  font-size: 16px;
}


.Polymatch_Age5:hover, .Polymatch_Age8:hover, .Polymatch_Age11:hover {
    background-color: #483d8b; /* Darker hover color */
    color: white; /* Change text color on hover for contrast */
}

.Polymatch_Age5 a, .Polymatch_Age8 a, .Polymatch_Age11 a {
    color: white;
    text-decoration: none;
    font-weight: bold;
    font-size: 16px;
}

.PolymatchResultsText {
    z-index: 22;
    align-self: center;
    height: max-content;
    margin: 0px;
    white-space: pre-wrap;
    overflow: visible;
    word-break: break-word;
    font-family: 'VanillaMilk'; /* Ensure you have imported or have access to the Vanilla font */
    font-size: 30px;
    color: rgb(139, 1, 148);
    text-align: center;
    line-height: 1.4;
    border-radius: 0px;
    opacity: 1;
}


@media (max-width: 768px) {
    .PolymatchSection_2 {
        flex-direction: column; /* Stack vertically on smaller screens */
        gap: 15px; /* Adjust spacing for smaller screens */
    }
}
.results-table-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    overflow-x: auto;
  }
  
  .results-table {
    border-collapse: collapse;
    width: 90%;
    max-width: 1000px;
    font-family: 'Vanilla', sans-serif; /* Assuming the Vanilla font is correctly installed */
    font-size: 16px;
    color: #000;
    text-align: left;
  }
  
  .results-table th, .results-table td {
    border: 1px solid #ddd;
    padding: 8px;
  }
  
  .results-table th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #f2f2f2;
    color: #333;
  }
  
  .results-table td {
    text-align: center;
  }
  
  .results-table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .results-table tr:hover {
    background-color: #f1f1f1;
  }
  

`, "",{"version":3,"sources":["webpack://./src/MyComponents/PromotionalPages/PolymatchResults.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB,EAAE,uBAAuB;IAChD,SAAS,EAAE,uBAAuB;IAClC,gBAAgB,EAAE,0CAA0C;AAChE;;AAEA;IACI,WAAW,EAAE,yBAAyB;IACtC,kBAAkB,EAAE,oBAAoB;IACxC,kBAAkB,EAAE,oBAAoB;IACxC,kBAAkB;IAClB,eAAe;IACf,sCAAsC,EAAE,wBAAwB;AACpE;AACA;EACE,yBAAyB;AAC3B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;EACE,yBAAyB,EAAE,uBAAuB;EAClD,YAAY,EAAE,4CAA4C;AAC5D;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;;AAGA;IACI,yBAAyB,EAAE,uBAAuB;IAClD,YAAY,EAAE,4CAA4C;AAC9D;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B,EAAE,gEAAgE;IAC5F,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;;AAGA;IACI;QACI,sBAAsB,EAAE,wCAAwC;QAChE,SAAS,EAAE,uCAAuC;IACtD;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,UAAU;IACV,iBAAiB;IACjB,kCAAkC,EAAE,qDAAqD;IACzF,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".PolymatchSection_2 {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center; /* Center the buttons */\n    gap: 20px; /* Consistent spacing */\n    margin-top: 20px; /* Add space above the section if needed */\n}\n\n.Polymatch_Age4, .Polymatch_Age5, .Polymatch_Age8, .Polymatch_Age11 {\n    width: auto; /* Set consistent width */\n    padding: 15px 25px; /* Uniform padding */\n    border-radius: 8px; /* Rounded corners */\n    text-align: center;\n    cursor: pointer;\n    transition: background-color 0.3s ease; /* Smooth hover effect */\n}\n.Polymatch_Age4 {\n  background-color: #dd2ba2;\n}\n.Polymatch_Age5 {\n    background-color: #dbaf1f;\n}\n\n.Polymatch_Age8  {\n    background-color: #688cd9;\n}\n.Polymatch_Age11{\n    background-color: #58da6e;\n}\n.Polymatch_Age4:hover, .Polymatch_Age8:hover, .Polymatch_Age11:hover {\n  background-color: #483d8b; /* Darker hover color */\n  color: white; /* Change text color on hover for contrast */\n}\n.Polymatch_Age4 a, .Polymatch_Age8 a, .Polymatch_Age11 a {\n  color: white;\n  text-decoration: none;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n\n.Polymatch_Age5:hover, .Polymatch_Age8:hover, .Polymatch_Age11:hover {\n    background-color: #483d8b; /* Darker hover color */\n    color: white; /* Change text color on hover for contrast */\n}\n\n.Polymatch_Age5 a, .Polymatch_Age8 a, .Polymatch_Age11 a {\n    color: white;\n    text-decoration: none;\n    font-weight: bold;\n    font-size: 16px;\n}\n\n.PolymatchResultsText {\n    z-index: 22;\n    align-self: center;\n    height: max-content;\n    margin: 0px;\n    white-space: pre-wrap;\n    overflow: visible;\n    word-break: break-word;\n    font-family: 'VanillaMilk'; /* Ensure you have imported or have access to the Vanilla font */\n    font-size: 30px;\n    color: rgb(139, 1, 148);\n    text-align: center;\n    line-height: 1.4;\n    border-radius: 0px;\n    opacity: 1;\n}\n\n\n@media (max-width: 768px) {\n    .PolymatchSection_2 {\n        flex-direction: column; /* Stack vertically on smaller screens */\n        gap: 15px; /* Adjust spacing for smaller screens */\n    }\n}\n.results-table-container {\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n    overflow-x: auto;\n  }\n  \n  .results-table {\n    border-collapse: collapse;\n    width: 90%;\n    max-width: 1000px;\n    font-family: 'Vanilla', sans-serif; /* Assuming the Vanilla font is correctly installed */\n    font-size: 16px;\n    color: #000;\n    text-align: left;\n  }\n  \n  .results-table th, .results-table td {\n    border: 1px solid #ddd;\n    padding: 8px;\n  }\n  \n  .results-table th {\n    padding-top: 12px;\n    padding-bottom: 12px;\n    text-align: center;\n    background-color: #f2f2f2;\n    color: #333;\n  }\n  \n  .results-table td {\n    text-align: center;\n  }\n  \n  .results-table tr:nth-child(even) {\n    background-color: #f9f9f9;\n  }\n  \n  .results-table tr:hover {\n    background-color: #f1f1f1;\n  }\n  \n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
